import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import cx from 'classnames';
import ColorsForm from '../ColorsForm/ColorsForm';
import GroupForm from '../GroupForm/GroupForm';
import OptionsForm from '../OptionsForm/OptionsForm';
import s from './TransportPanelAddition.css';

class TransportPanelAddition extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    children: PropTypes.node,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    children: null,
  };

  handleColorsChange = id => {
    this.props.selectedActions.set.colors(id);
  };

  handlePhotosToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.photos(!formState.photos ? 1 : null);
  };

  handleSwapToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.isSwap(!formState.isSwap ? 1 : null);
  };

  handleUnderLoanToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.isUnderLoan(!formState.isUnderLoan ? 1 : null);
  };

  handleFromAuctionToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.fromAuction(!formState.fromAuction ? 1 : null);
  };

  render() {
    const { formVocabulary, formState, selectedActions, children, intl } = this.props;
    const { colors, dealers, capacities, rent, credits, customs, states, options } = formVocabulary;
    const selectedSetActions = selectedActions.set;
    const [formattedCredits, formattedStates, formattedRent, formattedDealers, formattedCustoms] = [
      credits,
      states,
      rent,
      dealers,
      customs,
    ].map(propsArray =>
      propsArray.map(({ title, ...props }) => ({
        ...props,
        title: intl.formatMessage({ id: title }),
      })),
    );

    const isWater = formState.transport && formState.transport.slug === 'vodnyi-transport';

    return (
      <div className={s.fullForm}>
        <div className={s.filterItem}>
          <ColorsForm
            colors={colors}
            selectedColors={formState.colors}
            selectColor={this.handleColorsChange}
          />
        </div>
        {!isWater && (
          <React.Fragment>
            <div className={s.filterItem}>
              <RegexpInput
                className={cx(s.input, s.from)}
                type="text"
                placeholder={intl.formatMessage({ id: 'Мощность от, ' })}
                value={formState.powerFrom || ''}
                onChange={selectedSetActions.powerFrom}
                pattern={'^[0-9]+$'}
              />
              <RegexpInput
                className={cx(s.input, s.to)}
                type="text"
                placeholder={intl.formatMessage({ id: 'до, л.с.' })}
                value={formState.powerTo || ''}
                onChange={selectedSetActions.powerTo}
                pattern={'^[0-9]+$'}
              />
            </div>
            <div className={s.filterItem}>
              <div className={s.flexContainer}>
                <Select
                  className={s.selectFrom}
                  placeholder={intl.formatMessage({ id: 'Объем от, ' })}
                  instanceId="capacity-from-ff"
                  name="capacity-from"
                  labelKey="title"
                  valueKey="id"
                  options={capacities}
                  value={formState.capacityFrom}
                  onChange={selectedSetActions.capacityFrom}
                />
                <Select
                  className={s.selectTo}
                  placeholder={intl.formatMessage({ id: 'до, л' })}
                  instanceId="capacity-to-ff"
                  name="capacity-to"
                  labelKey="title"
                  valueKey="id"
                  options={capacities}
                  value={formState.capacityTo}
                  onChange={selectedSetActions.capacityTo}
                />
              </div>
            </div>
          </React.Fragment>
        )}

        {children}

        <div className={s.filterItem}>
          {false && (
            <GroupForm
              items={formattedDealers}
              selected={formState.dealerType}
              disabled
              handleSelect={selectedSetActions.dealerType}
            />
          )}
          <Select
            placeholder={intl.formatMessage({ id: 'Аренда' })}
            instanceId="rent-ff"
            name="rent"
            labelKey="title"
            valueKey="id"
            searchable={false}
            options={formattedRent}
            onChange={selectedSetActions.isRent}
            value={formState.isRent}
          />
        </div>
        <div className={s.filterItem}>
          <Select
            placeholder={intl.formatMessage({ id: 'Кредит' })}
            instanceId="credit-ff"
            name="credit"
            labelKey="title"
            valueKey="id"
            searchable={false}
            options={formattedCredits}
            onChange={selectedSetActions.isSaleOnCredit}
            value={formState.isSaleOnCredit}
          />
        </div>
        <div className={s.filterItem}>
          <div className={s.flexContainer}>
            <div className={s.left}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handleSwapToggle}
                  checked={!!formState.isSwap}
                />{' '}
                <FormattedMessage id="Обмен" />
              </label>
            </div>
            <div className={s.right}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handleUnderLoanToggle}
                  checked={!!formState.isUnderLoan}
                />{' '}
                <FormattedMessage id="Кредитный" />
              </label>
            </div>
          </div>
        </div>
        <div className={s.filterItem}>
          <Select
            placeholder={intl.formatMessage({ id: 'Cостояние' })}
            instanceId="state-ff"
            name="state"
            labelKey="title"
            valueKey="id"
            searchable={false}
            disabled={!!formState.isNew}
            options={formattedStates}
            onChange={selectedSetActions.isCrashed}
            value={formState.isCrashed}
          />
        </div>
        <div className={s.filterItem}>
          <Select
            placeholder={intl.formatMessage({ id: 'Растаможка' })}
            instanceId="customs-ff"
            name="customs"
            labelKey="title"
            valueKey="id"
            searchable={false}
            options={formattedCustoms}
            onChange={selectedSetActions.isNotCleared}
            value={formState.isNotCleared}
          />
        </div>
        <div className={s.filterItem}>
          <div className={s.flexContainer}>
            <div className={s.left}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handlePhotosToggle}
                  checked={!!formState.photos}
                />{' '}
                <FormattedMessage id="Только с фото" />
              </label>
            </div>
            <div className={s.right}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handleFromAuctionToggle}
                  checked={!!formState.fromAuction}
                />{' '}
                <FormattedMessage id="С аукциона" />
              </label>
            </div>
          </div>
        </div>
        <OptionsForm options={options} />
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(TransportPanelAddition));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/TransportPanelAddition/TransportPanelAddition.js